<template lang="pug">
  div(
    @click.stop.prevent=""
  ).route-schedule-block-update
    e-modal(
    @close="close()"
    @confirm="save()"
    :showFooter="false"
    )
      template(slot="header")
          span.close(@click="close()")
          h1.title Назначить мусоровоз на <br> маршрут {{route.name}}
          div.route-info
            label Приблизительная длительность маршрута:
            span {{route.duration}}
          div.route-info
            label Требуемая вместимость мусоровоза:
            span >{{neededCapacity}} т
      slot
        div.body.body--noPadding
          div.col
            div.col-block
              div.table.table--thin
                table
                  thead
                    th Подходящие мусоровозы
                    th

                  tbody(
                    v-if="cars && cars.data && cars.data.length > 0"
                  )
                    tr(
                      v-for="item in cars.data"
                      @click="selectItem(item)"
                      :class="isActive(item) ? '' : 'inactive' "
                    )
                      td {{item.brand}} {{item.model}}, {{item.number}}
                      td {{isOnRepair(item) ? 'На ремонте' : 'Исправна'}}

                  tbody(
                  v-else
                  )
                    tr
                      td Нет мусоровозов
                      td
      div(
        style="z-index: 99999;"
      ).footer
        div(
        v-if="selectedCar && selectedCar.car && selectedCar.car.id"
        ).set-date
          // label busyRange: {{busyRange}}
          label Доступное время мусоровоза {{selectedCar.car.brand}} {{selectedCar.car.model}}, {{selectedCar.car.number}}

          e-slider(
          v-model="selectedCar.time_range"
          :min="TIME_RANGE_MIN"
          :max="TIME_RANGE_MAX"
          range
          show-stops
          :disabled-range="busyRange"
          :format-tooltip="formatTime"
          :format-caption="formatTime"
          )

        div.actions-filter-panel.actions-filter-panel--right
          div
            button(
            v-if="currentCarId"
            type="button"
            @click="remove()"
            ).actions-filter-panel__button.standart Снять с маршрута
            button(
             v-if="saving"
             @click=""
            ).actions-filter-panel__button.standart Назначение...
            button(
              v-else
              type="button"
              @click="save()"
            ).actions-filter-panel__button.standart Назначить
</template>

<script>
  import {transport} from '../../../api/api-endpoints.js'

  const DEFAULT_TIME_RANGE = [8, 8]

  export default {
    name: 'route-schedule-block-update',
    props: {
      dayInWeek: Number,
      dayInfo: Object,
      year: '',
      week: '',
      month: '',
      day: '',
      route: Object,
      currentCar: Object,
      cars: Object,
      shedules: Object
    },
    data: () => ({
      selectedCar: {
        time_range: DEFAULT_TIME_RANGE,
        car: {},
        dayInfo: {},
        route_id: null
      },
      saving: false
    }),
    watch: {
      'currentCar': {
        handler: 'onCurrentCar',
        deep: true
      }
    },
    computed: {
      TIME_RANGE_MIN () {
        return 8
      },
      TIME_RANGE_MAX () {
        return 17
      },
      neededCapacity () {
        let sum = 0
        if (this.route && this.route.msn && this.route.msn.length > 0) {
          this.route.msn.forEach(v => {
            sum = sum + v.volume_count * 1
          })
        }
        sum = sum.toFixed(2)
        if (isNaN(sum)) {
          sum = ' - '
        }
        return sum
      },
      currentCarId () {
        if (this.currentCar && this.currentCar.id) {
          return this.currentCar.id
        }
        return null
      },
      selectedCarKeyInWhatDay () {
        if (this.selectedCar && this.selectedCar.car) {
          return `car_${this.selectedCar.car.id}${this.year}${this.month}${this.day}`
        }
        return null
      },
      carsInWhatDay () {
        if (this.selectedCarKeyInWhatDay) {
          return this.shedules[this.selectedCarKeyInWhatDay] || null
        }
        return null
      },
      busyRange () {
        let busyRange = []
        let cars = this.carsInWhatDay
        console.log('carsInWhatDay', this.carsInWhatDay)
        if (cars) {
          cars.forEach(v => {
            if (this.currentCarId !== v.id) {
              let tR = v.time_range
              if (tR && tR.length) {
                for (let i = tR[0]; i <= tR[1]; i++) {
                  busyRange.push(i)
                }
              }
            }
          })
        }
        return busyRange
      }
    },
    created () {
      this.setSelectedCarFromCurrent()
    },
    methods: {
      isOnRepair (item) {
        //TODO
        //if (item && item.year % 2 !== 0) {
        //  return false
        //}
        //return true
        return false
      },
      isActive (item) {
        //TODO вернуть обратно: !isNaN(this.neededCapacity) && item.car && item.car.capacity >= (this.neededCapacity * 1000) && this.isOnRepair(item) === false
        return true
      },
      formatTime (v) {
        return `${v > 9 ? v : '0' + v}:00`
      },
      remove () {
        if (!this.currentCarId) {
          return
        }
        this.$store.dispatch('deleteModel', {
          url: transport.routeScheduleItem(this.currentCarId)
        }).then(() => {
          this.$emitter.emit('routes.route-schedule-block-update', {})
          this.selectedCar = Object.create(null)
          this.$e.successBox('Машина снята с маршрута')
          this.close()
        }).catch(e => {
          this.$e.errorBox(e)
        })
      },
      setSelectedCarFromCurrent () {
        if (this.currentCarId) {
          this.selectedCar = Object.assign({}, this.currentCar)
        }
      },
      onCurrentCar () {
        if (this.selectedCar && this.selectedCar.id) {} else {
          this.setSelectedCarFromCurrent()
        }
      },
      getUpdateOrCreateUrl (id) {
        if (id) {
          return transport.routeScheduleItem(id)
        }
        return transport.routeScheduleItem()
      },
      selectItem (item) {
        if (this.isActive(item)) {
          this.selectedCar.car = item
          this.selectedCar.route_id = this.route.id
          this.selectedCar.time_range = DEFAULT_TIME_RANGE
          this.selectedCar = Object.assign({}, this.selectedCar)
        }
      },
      validate () {
        if (this.selectedCar.time_range && this.selectedCar.time_range[0] && this.selectedCar.time_range[1] && (this.selectedCar.time_range[1] - this.selectedCar.time_range[0]) > 0) {} else {
          this.$e.warningBox('Укажите время, передвигая ползунок')
          return false
        }
        return true
      },
      save () {
        if (!this.validate()){
          return
        }
        this.saving = true
        let action = 'createModel'
        let data = Object.assign({}, this.selectedCar)
        data.dayInfo = this.dayInfo
        data.day = data.dayInfo.day || null
        data.month = data.dayInfo.month || null
        data.week = data.dayInfo.week || null
        data.year = data.dayInfo.year || null
        data.route_id = this.route.id
        data.tko_transport_id = this.selectedCar && this.selectedCar.car ? this.selectedCar.car.id : null
        if (this.currentCarId) {
          data.id = this.currentCarId
          action = 'updateModel'
        }
        this.$store.dispatch(action, {
          url: this.getUpdateOrCreateUrl(data.id),
          data
        }).then(() => {
          this.saving = false
          this.$emitter.emit('routes.route-schedule-block-update', {})
          this.$e.successBox('Машина назначена')
          this.close()
          this.selectedCar = Object.create(null)
        }).catch(e => {
          console.error(e)
          this.saving = false
          this.close()
          this.$e.errorBox(e)
        })
      },
      close () {
        if (!this.saving) {
          this.$emit('close')
        }
      }
    }
  }
</script>
